<template>
  <div class="rel home">
    <Top></Top>
    <button class="abs auto entry" @click="entry"></button>
    <img src="@images/entryTip.png" alt="" class="abs auto entryTip">
  </div>
</template>

<script>
import Top from '@/components/top/Top.vue'
import { showPage, showPop } from '@/utils/common.js';
import { mapState } from 'vuex';

export default {
  data(){
    return {
      guideEnd: localStorage.getItem('guideEnd')
    }
  },
  components: {
    Top
  },
  computed: {
    ...mapState(['isLogin', 'isBind']),
  },
  methods: {
    showPage,
    showPop,
    entry(){
      if(!this.isLogin){
        $.islogin(true);
        return;
      }
      if(!this.isBind){
        this.showPop('Bind');
        return;
      }
      if(this.guideEnd){
        this.showPage('GetHead');
      }else{
        this.showPage('Guide');
      }
    }
  }
}
</script>

<style scoped>
.home{ height: 100%; background: url(@images/home.jpg) no-repeat center top;}
.entry{ top: 1039px; width: 425px; height: 103px; background: url(@images/entry.png) no-repeat 0 0;}
.entryTip{ top: 1158px;}
</style>